import { jsonName } from "../../decorators/json-name";
import { TxnType } from "../../types";
import { TransactionRequest } from "../transaction-request";

export class PurchaseRequest extends TransactionRequest {
  constructor(input: { AmountPurchase: number }) {
    super();
    this.AmountPurchase = input.AmountPurchase;
  }

  TxnType = TxnType.Purchase;

  // The cash out amount (in cents) of the transaction. Defaults to 0
  @jsonName("AmtCash")
  AmountCash?: number;

  // The purchase amount (in cents) of the transaction.
  @jsonName("AmtPurchase")
  AmountPurchase: number;
}
